import { inject } from 'vue'
import type { Plugin } from 'vue'
import type { Router } from 'vue-router'

import { ConsoleTracker } from './consoleTracker'

const TRACKER_KEY = 'tracker'

export interface UserData {
  id: string
  userId?: string
  name?: string
  location_id?: string
  organization_id?: string
  accessToken?: string
}

export interface Tracker {
  trackerId: string
  identify(userData: UserData): void
  track(
    eventName: string,
    eventProperties?: Record<string, any>,
    userProperties?: Record<string, any>
  ): void
  /**
   * Function to check if the user has a feature flag
   * @param name string of the feature flag
   * @returns true if the feature flag is active, false otherwise
   */
  hasFeatureFlag(name: string): Promise<boolean>
  clear(): void
  getRawTracker(): any
}

export const trackerPlugin: Plugin<[{ router?: Router; tracker: Tracker }]> = {
  install(app, options) {
    const router: Router | undefined = options.router
    const tracker: Tracker = options.tracker
    app.provide(TRACKER_KEY, tracker)
    if (router) {
      router.afterEach(to => {
        tracker.track('$pageview', {
          path: to.path
        })
      })
    }
  }
}

export function useTracker() {
  return inject<Tracker>(TRACKER_KEY, new ConsoleTracker())
}
